import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponentComponent } from './login-component/login-component.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { LinkSentSuccessfullyComponent } from './link-sent-successfully/link-sent-successfully.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PasswordResetSuccessfullyComponent } from './password-reset-successfully/password-reset-successfully.component';
import { PreLoginComponent } from './pre-login/pre-login.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: LoginComponentComponent,
        children: [
          {
            path: '',
            component: LoginFormComponent,
          },
          {
            path: 'forget-password',
            component: ForgetPasswordComponent,
          },
          {
            path: 'link-sent',
            component: LinkSentSuccessfullyComponent,
          },
          {
            path: 'reset-password',
            component: ResetPasswordComponent,
          },
          {
            path: 'password-changed-successfully',
            component: PasswordResetSuccessfullyComponent,
          },
          {
            path: 'prelogin',
            component:PreLoginComponent,
          },
        ],
      },
    ]),
  ],

  exports: [RouterModule],
})
export class LoginRoutingModule {}
